import React, { memo } from 'react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from './SmsCard.module.sass'

const SmsCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const { i18n } = useGlobal()

		return (
			<div
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''}`}
			>
				<HStack
					className={styles['top-row']}
					justify='space-between'
					align='flex-start'
					gap='small'
				>
					<VStack gap='small'>
						<HStack gap='xsmall' align='center'>
							<Icon width='18px' height='18px' name='chat-bubble' />
							<h5>{data.number || i18n`Not defined`}</h5>
						</HStack>
						<VStack>
							<span>
								<small>
									{i18n`Sent by ${data.creationUser || i18n`Not defined`}`}
								</small>
							</span>
						</VStack>
					</VStack>

					<VStack className={styles['date-container']} gap='small'>
						<small>
							<Icon
								className={styles['text-icon']}
								width='12px'
								height='12px'
								name='calendar'
							/>
							{data.creationDate?.dateTimeFormat}
						</small>
					</VStack>
				</HStack>

				<VStack className={styles['message-container']} gap='small'>
					{data.message && (
						<div dynamic='true' className={styles['message-body']}>
							{data.message}
						</div>
					)}
					{data.resultText && (
						<small className={styles['message-result']}>
							{data.resultText}
						</small>
					)}
				</VStack>
			</div>
		)
	},
	(prevProps, nextProps) => prevProps.data === nextProps.data
)

export default SmsCard
